import React from 'react';
import AdminLayout from '../../../Components/CommonComponents/Layout/adminLayout';
import EventTypesContainer from '../../../Containers/AdminContainer/EventTypes';

const EventTypesScreen = () => {
  return <EventTypesContainer />;
};

export default EventTypesScreen;
